<template>
  <div>
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClickBtn"
      @searchCompanyName="searchCompanyName"
      @searchBtnClick="search"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field === 'businessType'">
              {{
                dictListMap?.businessCategory.find(
                  (item) => item.value == scope.row['businessType']
                )?.label
              }}</span
            >
            <span v-else-if="item.field === 'expenseTypeCode'">{{
              scope.row['expenseTypeCode'] == '01' ? '结算开票(货款)' : '非结算开票'
            }}</span>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="scope.row[item.field]"
                @click="goOaLink(scope.row[item.field])"
                >查看</a
              >
            </template>
            <template
              v-else-if="
                [
                  'invoiceAccountedAmount',
                  'invoicedAmount',
                  'excludedTaxAmount',
                  'taxAmount',
                  'taxRate',
                  'invoiceAmount',
                  'excludedTaxAccountedAmount',
                  'taxAccountedAmount',
                ].includes(item.field)
              "
            >
              {{
                userInfo.businessGroup == '物贸'
                  ? $utils.commafy($utils.toNumber(replaceZeroStr(scope.row[item.field])), {
                      digits: 2,
                    })
                  : replaceZeroStr(scope.row[item.field])
              }}
            </template>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import BASE_API from '@/api/dataBase.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/financeCenter/saleInvoice.js';
  import { filterEmpty, getUserCompanyList } from '@/common/js/util';
  import { commonConfirmAction, voucherAction } from './components/actions';
  import { columns } from './components/data';
  import tableMixins from '@/common/mixins/table.js';
  import XEUtils from 'xe-utils';
  export default {
    name: 'saleInvoiceList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
    },
    data() {
      return {
        footerTotalCols: {
          amount: ['invoiceAmount', 'excludedTaxAmount', 'taxAmount', 'ladingDifferenceAmount'],
          quantity: ['invoiceQuantity'],
        }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        load: false,
        tableData: [],
        query: {
          // voucherNo: null,
          // differInvoice: false,
          invoiceCompanyCode: '',
          invoiceDepartmentCode: '',
          ladingNo: null,
          requestDepartmentNameLike: '',
          // goldenTaxType: null,
          // taxRateCode: null,
        },
        multipleSelection: [],
        companyList: [],
        departmentList: [],
        // columnListDefault: columns,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      columnListDefault() {
        console.log(columns(this), '-------->>>');
        return columns(this);
      },
      searchColumns() {
        return [
          {
            prop: 'invoiceCompanyCode',
            name: this.$t('payablesBillList.search.payableInvoiceCompanyName'),
            type: 'select',
            placeholder: this.$t('payablesBillList.search.companyCodePlaceholder'),
            options: getUserCompanyList(),
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            prop: 'invoiceDepartmentCode',
            name: this.$t('payablesBillList.search.payableInvoiceDepartmentCode'),
            placeholder: this.$t('payablesBillList.search.departPlaceholder'),
            type: 'select',
            options: this.departmentList,
            disabled: !this.query.invoiceCompanyCode,
          },
          {
            prop: 'orderCodeLike',
            name: '订单编码',
            type: 'input',
          },
          {
            type: 'dictSelect',
            prop: 'invoiceStatus',
            name: this.$t('saleInvoice.invoiceStatus'),
            apiData: { dictType: 'invoice_status' },
          },
          /* {
          type: 'ajaxSelect',
          prop: 'invoiceCompanyCode',
          name: '公司',
          name: this.$t('saleInvoice.invoiceCompany'),
          apiUrl: BASE_API.LIST_COMPANY_API,
          valueKey: 'id',
          apiData: {
            tenantCode: this.userInfo.tenantCode,
            adminFlag: this.userInfo.adminFlag
          },
        }, */

          {
            type: 'searchTableSpec',
            prop: 'partnerCodes',
            name: this.$t('saleInvoice.partnerName'),
            searchType: 'customer',
            extraData: {
              companyCode: this.query.invoiceCompanyCode,
              departmentCode: this.query.invoiceDepartmentCode,
              requestStatus: 'ZT03',
            },
          },
          {
            prop: 'businessType',
            name: '业务类别',
            type: 'select',
            clearable: false,
            options: this.dictListMap?.businessCategory,
          },
          {
            type: 'input',
            prop: 'contractNo',
            name: this.$t('saleInvoice.contractNoSearch'),
            // searchType: 'contract',
            // isMultiple: true,
          },
          {
            type: 'input',
            prop: 'outboundNo',
            name: this.$t('saleInvoice.outboundNo'),
          },
          {
            type: 'startDaterangePicker',
            prop: 'invoiceCreateDateBegin',
            name: this.$t('saleInvoice.invoiceCreateDateStart'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'invoiceCreateDateEnd',
            name: this.$t('saleInvoice.invoiceCreateDateEnd'),
          },
          {
            type: 'input',
            prop: 'invoiceNum',
            name: this.$t('saleInvoice.invoiceNum'),
          },
          {
            type: 'searchTableSpec',
            prop: 'invoiceCreatePersonCode',
            searchType: 'personnel',
            isMultiple: true,
            name: this.$t('saleInvoice.invoiceCreatePersonName'),
          },
          {
            type: 'startDaterangePicker',
            prop: 'goldenTaxDateBegin',
            name: this.$t('saleInvoice.goldenTaxDateStart'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'goldenTaxDateEnd',
            name: this.$t('saleInvoice.goldenTaxDateEnd'),
          },

          {
            type: 'dictSelect',
            prop: 'invoiceType',
            name: this.$t('saleInvoice.invoiceType'),
            apiData: { dictType: 'invoice_type' },
          },
          {
            type: 'dict',
            prop: 'issueStatus',
            name: '开票状态',
            dictType: 'invoiceIssueStatus',
          },
          {
            // type: 'dict',
            type: 'select',
            prop: 'expenseTypeCode',
            name: '费用类型',
            // dictType: 'expenseType',
            options: [
              { label: '结算开票(贷款)', value: '01' },
              { label: '非结算开票', value: '02' },
            ],
          },
          {
            name: '部门',
            prop: 'requestDepartmentNameLike',
            type: 'input',
          },
          // {
          //   type: 'dict',
          //   prop: 'taxRateCode',
          //   name: '税收分类',
          //   dictType: 'tax_class',
          // },

          // {
          //   prop: 'voucherNo',
          //   name: '凭证号',
          //   type: 'input',
          //   placeholder: this.$t('请输入凭证号'),
          // },
          // {
          //   prop: 'differInvoice',
          //   name: '是否差额发票',
          //   type: 'checkbox',
          // },
          // {
          //   prop: 'goldenTaxType',
          //   name: '增值税发票类型',
          //   type: 'dict',
          //   dictType: 'golden_tax_type',
          // },

          // {
          //   type: 'selectInput',
          //   prop: ['judgeFlag', 'ladingDifferenceAmount'],
          //   name: this.$t('saleInvoice.ladingDifferenceAmountTotal'),
          //   options: [
          //     { value: 1, label: '大于' },
          //     { value: 2, label: '小于' },
          //     { value: 3, label: '不等于' },
          //     { value: 4, label: '等于' },
          //   ],
          // },
          // {
          //   type: 'dictSelect',
          //   prop: 'accountingStatus',
          //   name: this.$t('saleInvoice.accountingStatus'),
          //   apiData: { dictType: 'post_status' },
          // },
          // {
          //   type: 'startDaterangePicker',
          //   prop: 'accountedDateBegin',
          //   name: this.$t('saleInvoice.accountedDateStart'),
          // },
          // {
          //   type: 'endDaterangePicker',
          //   prop: 'accountedDateEnd',
          //   name: this.$t('saleInvoice.accountedDateEnd'),
          // },
        ];
      },
    },
    mounted() {
      console.log(this.$route.query);
      this.initQuery();
      this.$nextTick(() => {
        // this.getCompany();
        this.getData();
        this.getButtonList();
        this.getdepartmentList(this.userInfo.companyCode);
      });
    },
    methods: {
      commonConfirmAction,
      voucherAction,
      errorTip(message) {
        this.$message({ showClose: true, message, type: 'error' });
      },

      resetBtnClickBtn() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        // this.query.invoiceCompanyCode = this.userInfo.companyCode;
        if (this.userInfo.companyCode != 'OAC19') {
          this.query = {
            invoiceCompanyCode: '',
            invoiceDepartmentCode: '',
          };
          // this.getdepartmentList(this.query.invoiceCompanyCode);
        }

        // this.query.invoiceDepartmentCode = this.userInfo.departmentCode;
        this.getData();
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.invoiceDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      // 获取部门
      getdepartmentList(companyCode) {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = (res.data.data.personDepartmentInfo || []).map((v) => {
              return {
                label: v.personDepartmentName,
                value: v.personDepartmentCode,
              };
            });
          } else {
            this.departmentList = [];
          }
        });
      },
      chooseClick(type) {
        console.log(type, '?');
        if (type == 'add') {
          this.handlePath('add');
          return;
        }
        const selectedList = this.$refs['siruiTable'].getCheckboxRecords(); // 选中数据
        if (type == 'export') {
          this.handleExport(selectedList, API.EXPORT_INVOICE);
          return;
        }
        if (selectedList.length == 0) {
          this.errorTip(this.$t('xTable.noSelectData'));
          return;
        }
        // 销售发票
        if (type == 'withdrawApprovalHandler') {
          if (selectedList.every((item) => item.invoiceStatus == 'submitted')) {
            const ids = selectedList.map((item) => item.id);
            this.loading.startLoading();
            this.$axios
              .post('/financial/financeSalesInvoice/batchWithdrawOA', {
                ids: ids,
                oaId: this.userInfo.oaId,
              })
              .then((res) => {
                const { code, msg } = res.data;
                this.loading.endLoading();
                console.log(res);
                if (code == 0) {
                  this.$message.success('撤回成功');
                  this.resetBtnClickBtn();
                } else {
                  this.$message.error(msg);
                }
              })
              .catch(() => {
                this.loading.endLoading();
              });
          } else {
            this.$message.error('只有已提交可以撤回审批');
          }
        }
        // 删除和批量提交状态一致
        if (type == 'delete' || type == 'submit') {
          const deleteStatus = ['saved', 'withdraw', 'returned'];
          const contractStatus = selectedList.some((item) => {
            return !deleteStatus.includes(item.invoiceStatus);
          });
          if (contractStatus) {
            const dsTip = type == 'submit' ? 'saleInvoice.submitTip' : 'saleInvoice.deleteTip';
            this.errorTip(this.$t(dsTip));
            return;
          }
          this.handleAction(type, selectedList);
        }
        // 批量生成凭证和撤回，只有已提交状态并且未入账和入账失败的可以
        if (type == 'withdraw') {
          this.handleAction(type, selectedList);
        }
        if (type == 'generateVoucher') {
          this.batchGenarateVoucher(
            'AE_AR_INVOICES',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
        // 批量过账
        if (type == 'syncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
        // 批量标记过账
        if (type == 'signSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_SIGN_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
        // 打印
        if (type == 'print') {
          this.print();
        }
        // 编辑
        if (type == 'edit') {
          this.edit();
          return;
        }
      },

      // //获取公司信息
      // async getCompany() {
      //   const selectStatus = await this.$axios.get(
      //     BASE_API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
      //   );
      //   if (selectStatus.data.code == 0) {
      //     this.companyList = selectStatus.data.data;
      //   }
      // },
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string') {
              query[item.prop] = undefined;
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, this.query, query, this.$route.query);
        if (this.userInfo.companyCode != 'OAC19') {
          // this.query.invoiceCompanyCode = this.userInfo.companyCode;
        }

        // this.query.invoiceDepartmentCode = this.userInfo.departmentCode;
      },
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        // if (!query.invoiceCompanyCode && this.userInfo.companyCode != 'OAC19') {
        //   this.$message({ showClose: true, message: '公司名称必填', type: 'error' });
        //   return;
        // }
        console.log('query', query);
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          partnerCodes: query.partnerCodes
            ? query.partnerCodes
                ?.map((item) => {
                  return item?.partnerCode;
                })
                .filter((item) => item)
            : [],
          // contractNo: query.contractNo ? query.contractNo[0].contractNo : '',
          invoiceCreatePersonCode: query.invoiceCreatePersonCode
            ? query.invoiceCreatePersonCode[0].id
            : '',
          differInvoice: query.differInvoice ? 1 : 0,
          businessGroup: this.userInfo.businessGroup,
        });
        return filterEmpty(result);
      },
      getData(search) {
        const params = this.getQuery();
        if (search && Object.keys(params).length == 2) {
          this.$message({
            showClose: true,
            message: this.$t('search.nosearchError'),
            type: 'error',
          });
          return;
        }
        this.load = true;
        // 获取数据
        this.$axios
          .post(API.GET_LIST, params)
          .then((res) => {
            this.load = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data.records;
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      handleAction(type, selectedList, cancelValidate) {
        let data = selectedList.map((item) => {
          return {
            id: item.id,
            version: item.version,
          };
        });
        if (type == 'delete' || type == 'withdraw') {
          this.commonConfirmAction(type, data, () => {
            this.getData();
          });
        }
        if (type == 'submit' || type == 'generateVoucher') {
          data = { ids: data.map((it) => it.id) };
          if (type == 'submit') {
            data.cancelValidate = cancelValidate;
            data.oaId = JSON.parse(this.userInfo.companyList).find(
              (it) => it.personCompanyCode == this.userInfo.companyCode
            )?.oaId;
            data.businessGroup = this.userInfo.businessGroup;
          }
          this.voucherAction(type, data, (res) => {
            if (res.data.code === 0) {
              this.getData();
            } else if (res.data.code === 10) {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.handleAction(type, selectedList, false);
                },
              });
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      handleExport() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'detailIds=' + item.detailId + '&';
          });
          window.location.href = `${this.baseUrl}${API.EXPORT_INVOICE}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.getQuery();
          delete params.pageNum;
          delete params.pageSize;
          params = XEUtils.serialize(params);
          var reg = new RegExp('%5B%5D', 'g');
          params = params.replace(reg, '');
          window.location.href = `${this.baseUrl}${API.EXPORT_INVOICE}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.$refs.siruiTable.setPageNum(1);
        this.getData(true);
      },
      // 列表双击
      dblclickEvent(e) {
        let path = {
          path: '/saleInvoice/detail',
          name: 'saleInvoiceDetail',
          meta: {
            keepAlive: true,
            title: '销售发票详情',
          },
          query: { id: e.row.id, isEdit: 'N' },
        };
        console.log(path);
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handlePath(type, id) {
        const pathName = type == 'add' ? 'saleInvoiceAdd' : 'saleInvoiceDetail';
        let url = type == 'add' ? '/saleInvoice/add' : '/saleInvoice/detail';
        let path = {
          path: url,
          name: pathName,
          meta: {
            keepAlive: true,
            title: '',
          },
          query: { id, isEdit: 'Y' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      edit() {
        console.log(111);
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length != 1) {
          this.$message({
            showClose: true,
            message: '请选择一条数据！',
            type: 'error',
          });
          return;
        }
        let obj = changeList[0];
        if (!['saved', 'withdraw', 'returned'].includes(obj.invoiceStatus)) {
          this.$message({
            showClose: true,
            message: '只有已保存，已撤回，已驳回的数据可以编辑！',
            type: 'error',
          });
          return;
        }
        let path = {
          path: '/saleInvoice/detail',
          name: 'saleInvoiceDetail',
          meta: {
            keepAlive: true,
            title: '编辑销售发票',
          },
          query: { id: obj.id, isEdit: 'Y' },
        };
        console.log(path);
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 打印
      print() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.printFlag = 'SALES_INVOICE';
        params.getFileUrl = API.GET_FILE;
        params.idList = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (!params.idList.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.printEntityCode(params);
      },
    },
  };
</script>
